var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-group btn-group-sm"},[(_vm.can_access('marketvalue','modify'))?_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Delete Currency"},on:{"click":function($event){return _vm.showModal('delete')}}},[_c('i',{staticClass:"fa fa-trash"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }